import apiClient from 'utilities/apiClient';

export const approver = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.approver}/${url}`, payload, true);
};

export const issuer = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.issuer}/${url}`, payload, true);
};

export const delete_requests = (url, payload) => {
  return apiClient.patch(`${apiClient.Urls.requester}/${url}`, payload, true);
};

export const print = (url, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.issuer_print}/${url}`,
    payload,
    true
  );
};

/* export const approverSearch = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.approverSearch}`, payload, true);
}; */
